import { useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { useModuleIds } from 'portal/lib/hooks'
import { productGroupsLoad } from 'portal/store/productGroups/actions'

export const useProductGroupsLoader = (overWriteProjectId = undefined) => {
  const dispatch = useDispatch()
  const { accountId, projectId: paramProjectId } = useModuleIds()

  const projectId = overWriteProjectId || paramProjectId

  const reload = useCallback(() => {
    if (!accountId || !projectId) {
      return
    }
    dispatch(productGroupsLoad(accountId, projectId))
  }, [dispatch, accountId, projectId])

  useEffect(() => {
    reload()
  }, [reload])

  const { loading, error, items } = useSelector((state: any) => {
    return state.productGroups
  })

  return {
    loading,
    error,
    items,
    reload
  }
}
